import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgToastSuccess = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.28 18.2201C9.75998 18.7401 8.91998 18.7401 8.39998 18.2201L3.61331 13.4334C3.36364 13.1843 3.22333 12.8461 3.22333 12.4934C3.22333 12.1407 3.36364 11.8025 3.61331 11.5534C4.13331 11.0334 4.97331 11.0334 5.49331 11.5534L9.33331 15.3934L18.5066 6.22008C19.0266 5.70008 19.8666 5.70008 20.3866 6.22008C20.9066 6.74008 20.9066 7.58008 20.3866 8.10008L10.28 18.2201Z",
		fill: "#62B86F"
	})
});
export { SvgToastSuccess as ReactComponent };
